class ColorGuideModal {
  constructor(modal) {
    this.modal = modal;
    this.tabs = modal.querySelectorAll('.color-guide-modal__tab');
    this.panels = modal.querySelectorAll('.color-guide-modal__panel');
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const season = tab.dataset.season;
        this.switchTab(season);
      });
    });
  }

  switchTab(season) {

    this.tabs.forEach(tab => {
      if (tab.dataset.season === season) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });


    this.panels.forEach(panel => {
      if (panel.dataset.season === season) {
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
      }
    });
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const colorGuideModals = document.querySelectorAll('.color-guide-modal');
  colorGuideModals.forEach(modal => {
    new ColorGuideModal(modal);
  });
});


document.addEventListener('click', (e) => {
  if (e.target.closest('[data-modal]')) {
    const modalId = e.target.closest('[data-modal]').dataset.modal;
    const modal = document.getElementById(modalId);
    if (modal && modal.classList.contains('color-guide-modal')) {
      if (!modal.dataset.initialized) {
        new ColorGuideModal(modal);
        modal.dataset.initialized = 'true';
      }
    }
  }
});

